import * as linkify from 'linkifyjs';

export default linkify as any;
